<template>
  <div>
    <div>
      <b-table
        striped
        hover
        :items="items"
        :fields="fields"
        :per-page="10"
        :current-page="currentPage"
        id="my-table"
      >
        <template v-slot:cell(actions)="data">
          <button
            class="btn btn-info btn-sm dropdown-toggle"
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            Action
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <b-button
              v-b-modal.modal-prevent-closing
              @click="openEditModal(data.item.id)"
              class="dropdown-item"
            >
              <i class="fa fa-edit"></i>
              Edit
            </b-button>
            <b-modal
              id="modal-prevent-closing"
              ref="modal"
              title="Edit Biochar Partner"
              @ok="updateBiocharPartner"
            >
              <form ref="form" @submit.stop.prevent="handleSubmit">
                <b-form-group label="Name" label-for="name-input">
                  <b-form-input id="name-input" v-model="editBiocharPartner.name">
                  </b-form-input>
                </b-form-group>
                <b-form-group label="Biomass Type" label-for="biomassType-input">
                  <b-form-select
                    id="biomassType-input"
                    v-model="editBiocharPartner.biomassType"
                    :options="biocharPartnerOptions"
                  ></b-form-select>
                </b-form-group>
                <b-form-group label="Biomass Waste" label-for="biomassWaste-input">
                  <div
                    v-for="(waste, index) in editBiocharPartner.biomassWaste"
                    :key="`waste-${index}`"
                    class="mb-2 url-input-row"
                  >
                    <b-form-input
                      v-model="editBiocharPartner.biomassWaste[index]"
                      placeholder="Enter Biomass Waste"
                    ></b-form-input>
                    <b-button
                      v-if="index > 0"
                      variant="danger"
                      size="sm"
                      class="mt-1 cancel-btn"
                      @click="removeBiomassWaste(index)"
                    >
                      ×
                    </b-button>
                  </div>
                  <b-button
                    variant="primary"
                    size="sm"
                    class="action-btn add-url-btn"
                    @click="addBiomassWaste"
                  >
                    Add More Biomass waste
                  </b-button>
                </b-form-group>
                <b-form-group label="Annual Feedstock" label-for="annualFeedstock-input">
                  <b-form-input id="annualFeedstock-input" v-model="editBiocharPartner.annualFeedstock" type="number">
                  </b-form-input>
                </b-form-group>
                <b-form-group label="Biochar Production" label-for="biocharProduction-input">
                  <b-form-input id="biocharProduction-input" v-model="editBiocharPartner.biocharProduction" type="number">
                  </b-form-input>
                </b-form-group>
                <b-form-group label="Potential Machine Cost" label-for="potentialMachineCost-input">
                  <b-form-input id="potentialMachineCost-input" v-model="editBiocharPartner.potentialMachineCost" type="number">
                  </b-form-input>
                </b-form-group>
                <b-form-group label="Capex Share Committed" label-for="capexShareCommitted-input">
                  <b-form-input id="capexShareCommitted-input" v-model="editBiocharPartner.capexShareCommitted" type="number">
                  </b-form-input>
                </b-form-group>
              </form>
            </b-modal>
            <button
              class="dropdown-item"
              @click="showDeletePrompt(data.item.id)"
            >
              <i class="fa fa-trash text-danger"></i>
              Delete
            </button>
          </div>
        </template>
      </b-table>

      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="10"
        aria-controls="my-table"
      ></b-pagination>
      <p class="mt-3">Current Page: {{ currentPage }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "BiocharPartner",
  data() {
    return {
      currentPage: 1,
      fields: [
        {
          key: "name",
          label: "Name",
        },
        {
          key: "biomassType",
          label: "Biomass Type",
        },
        {
          key: "biomassWaste",
          label: "Biomass Waste",
          formatter: (value) => Array.isArray(value) ? value.join(', ') : value
        },
        {
          key: "annualFeedstock",
          label: "Annual Feedstock",
        },
        {
          key: "biocharProduction",
          label: "Biochar Production",
        },
        {
          key: "potentialMachineCost",
          label: "Potential Machine Cost",
        },
        {
          key: "capexShareCommitted",
          label: "Capex Share Committed",
        },
        {
          key: "actions",
          label: "Action",
        },
      ],
      selected: null,
      biocharPartnerOptions: [
        { value: "Field Crops & Grains", text: "Field Crops & Grains" },
        { value: "Tree Crops & Fruits", text: "Tree Crops & Fruits" },
        { value: "Palm Kernel", text: "Palm Kernel" },
        { value: "Industrial Processing Waste", text: "Industrial Processing Waste" },
        { value: "Food Waste", text: "Food Waste" },
        { value: "Animal-based", text: "Animal-based" },
        { value: "Wood", text: "Wood" },
      ],
      items: [],
      editBiocharPartner: {
        name: "",
        biomassType: "",
        biomassWaste: [""],
        annualFeedstock: 0,
        biocharProduction: 0,
        potentialMachineCost: 0,
        capexShareCommitted: 0,
      },
    };
  },
  mounted() {
    this.getBiocharPartner();
  },
  computed: {
    rows() {
      return this.items.length;
    },
  },
  methods: {
    async getBiocharPartner() {
      try {
        const response = await this.$store.dispatch("markers/fetchBiocharPartners");
        this.items = response.features.map(partner => ({
          id: partner.properties.id || "",
          name: partner.properties.name || "",
          biomassType: partner.properties.biomassType || "",
          biomassWaste: partner.properties.biomassWaste ?  partner.properties.biomassWaste.split(',').map(waste => waste.trim()) : [""],
          annualFeedstock: partner.properties.annualFeedstock || 0,
          biocharProduction: partner.properties.biocharProduction || 0,
          potentialMachineCost: partner.properties.potentialMachineCost || 0,
          capexShareCommitted: partner.properties.capexShareCommitted || 0,
        }));
      } catch (error) {
        console.error("Error fetching biochar partners:", error);
        this.$toastr.e("Failed to load biochar partners");
      }
    },
    async showDeletePrompt(itemId) {
      try {
        const isDeleteConfirmed = await this.$bvModal.msgBoxConfirm(
          "Please confirm that you want to delete this Biochar Partner.",
          {
            size: "md",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        );
        if (!isDeleteConfirmed) return;
        const res = await this.$store.dispatch(
          "markers/deleteBiocharPartner",
          itemId
        );
        if (res.status === 204) {
          this.$toastr.i("Biochar Partner successfully deleted");
          const idx = this.items.findIndex((partner) => partner.id === itemId);
          this.items.splice(idx, 1);
        }
      } catch (error) {
        console.error("Error deleting biochar partner:", error);
        this.$toastr.e("Failed to delete biochar partner");
      }
    },
    async openEditModal(id) {
      try {
        const biocharPartner = await this.$store.dispatch(
          "markers/fetchSingleBiocharPartner",
          id
        );
        this.editBiocharPartner = {
          id: biocharPartner._id || "",
          name: biocharPartner.name || "",
          biomassType: biocharPartner.biomassType || "",
          biomassWaste: biocharPartner.biomassWaste || [""],
          annualFeedstock: biocharPartner.annualFeedstock || 0,
          biocharProduction: biocharPartner.biocharProduction || 0,
          potentialMachineCost: biocharPartner.potentialMachineCost || 0,
          capexShareCommitted: biocharPartner.capexShareCommitted || 0,
        };
      } catch (error) {
        console.error("Error fetching biochar partner:", error);
        this.$toastr.e("Failed to load biochar partner details");
      }
    },
    async updateBiocharPartner() {
      try {
        const payload = {
          id: this.editBiocharPartner.id,
          name: this.editBiocharPartner.name,
          biomassType: this.editBiocharPartner.biomassType,
          biomassWaste: this.editBiocharPartner.biomassWaste.filter(waste => waste.trim() !== ""),
          annualFeedstock: Number(this.editBiocharPartner.annualFeedstock),
          biocharProduction: Number(this.editBiocharPartner.biocharProduction),
          potentialMachineCost: Number(this.editBiocharPartner.potentialMachineCost),
          capexShareCommitted: Number(this.editBiocharPartner.capexShareCommitted),
        };
        
        console.log("Update payload:", payload);
        const res = await this.$store.dispatch(
          "markers/updateBiocharPartner",
          payload
        );
        
        if (res.status === 200) {
          this.$toastr.i("Biochar Partner successfully updated");
          this.$bvModal.hide('modal-prevent-closing');
          this.getBiocharPartner();
        }
      } catch (error) {
        console.error("Error updating biochar partner:", error);
        this.$toastr.e("Failed to update biochar partner");
      }
    },
    addBiomassWaste() {
      this.editBiocharPartner.biomassWaste.push("");
    },
    removeBiomassWaste(index) {
      this.editBiocharPartner.biomassWaste.splice(index, 1);
      if (this.editBiocharPartner.biomassWaste.length === 0) {
        this.editBiocharPartner.biomassWaste.push("");
      }
    },
    handleSubmit() {
    },
  },
};
</script>

<style>
.dashboard {
  display: flex;
  flex-direction: column;
}

.navbar {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-around;
  align-items: right;
  background-color: #09571d;
  color: #fff;
}

.navbar a {
  color: #fff;
  text-decoration: none;
}

.body {
  display: flex;
  justify-content: center;
}

.sidebar {
  width: 20%;
  background-color: #f5f5f5;
  padding: 20px;
}

.main-content {
  width: 80%;
  padding: 20px;
}

.url-input-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.url-input-row .form-control {
  flex: 1;
}

.cancel-btn {
  padding: 0.25rem 0.5rem;
}

.add-url-btn {
  margin-top: 8px;
}
</style>